import NewsHeadline from './news-headline';

export default class NewsHeadlineDesktop extends NewsHeadline {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/news-headline/news-headline.desktop.js